import type { Messages } from "../types";

export const fi = {
  "common": {
    "brand": "UN8",
    "brandTag": "Eksklusiivinen kristillinen deittailu",
    "continue": "Jatka",
    "leave": "Poistu",
    "leaveForNow": "Poistu toistaiseksi",
    "yes": "Kyllä",
    "no": "Ei",
    "goBack": "Takaisin",
    "saving": "Tallennetaan…",
    "submitting": "Lähetetään…",
    "pleaseWait": "Odota hetki…",
    "ellipsis": "…",
    "male": "Mies",
    "female": "Nainen",
    "phases": {
      "gate": "Portti",
      "verify": "Vahvista",
      "setup": "Asetukset",
      "profile": "Profiili"
    },
    "storageQuota": "Tässä puhelimessa ei ole tilaa tallennetuille vastauksille. Vapauta tallennustilaa ja yritä uudelleen.",
    "storageDisabled": "Tämä selain ei tallenna vastauksiasi. Poista yksityinen tila käytöstä tai salli sivuston tiedot ja lataa sivu uudelleen.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "vähintään {min} merkkiä"
  },
  "welcome": {
    "promise": "Tavoitteemme on, että poistat tämän sovelluksen mahdollisimman nopeasti.",
    "sub": "UN8 auttaa vakavia kristittyjä sinkkuja löytämään elämänkumppanin — ja sitten lähtemään. Vahvistettu. Arvot ensin. Ei loputonta swippausta.",
    "signedInAs": "Kirjautunut sisään: {email}",
    "liveServer": " · live-palvelin",
    "deviceOnly": " · vain tämä laite",
    "migrateOffer": "Tällä laitteella on vielä paikallinen profiili. Ladataanko se jaetulle palvelimelle, jotta muut puhelimet näkevät sinut moderoinnin jälkeen? Mitään ei ladata ennen kuin valitset.",
    "uploadLocalProfile": "Lataa paikallinen profiilini",
    "keepOnDevice": "Pidä vain tällä laitteella",
    "migrateNeedGender": "Valitse ensin profiilissasi Mies tai Nainen.",
    "migrateDone": "Profiiliteksti ladattu. Lataa uudelleen henkilöllisyystodistus, video ja kuvat, jotta moderointi voi tarkistaa ne.",
    "deleteConfirm": "Poistetaanko tilisi, kaikki viestit ja kaikki media (mukaan lukien henkilöllisyystodistus ja video) pysyvästi palvelimelta?",
    "accountDeleted": "Tili poistettu.",
    "begin": "Aloita",
    "continueOnboarding": "Jatka käyttöönottoa",
    "logIn": "Kirjaudu sisään",
    "logOut": "Kirjaudu ulos",
    "reviewConsole": "Tarkistuskonsole",
    "matching": "Matchaus",
    "deleteMyAccount": "Poista tilini"
  },
  "faith": {
    "eyebrow": "Uskon portti",
    "title": "Vain kristityille",
    "text": "UN8 on Jeesuksen Kristuksen seuraajien yhteisö jäsenille, jotka etsivät avioliittoon suuntautuvaa kumppania, joka jakaa saman uskon. Tätä porttia ei voi ohittaa.",
    "yesTitle": "Olen kristitty",
    "yesBody": "Seuraan Jeesusta Kristusta ja etsin avioliittoon suuntautuvaa kumppania, joka jakaa tämän uskon.",
    "noTitle": "En ole kristitty",
    "noBody": "UN8 ei ole oikea paikka minulle — ja se on ihan ok.",
    "respectTitle": "Kunnioittaen",
    "respectBody": "UN8 on rakennettu yhdelle yhteisölle, ja mieluummin olemme rehellisiä kuin tuhlaamme aikasi. Käytä alla Poistu tai Takaisin, jos tämä ei ole kotisi.",
    "sharedTitle": "Yhteinen perusta",
    "sharedBody": "Usko ei ole täällä etiketti. Se on maa, jolla tapaatte.",
    "hintNotChristian": "UN8 on Jeesuksen Kristuksen seuraajille. Napauta alla Poistu tai valitse kristitty-vaihtoehto, jos se olet sinä.",
    "hintUnset": "Napauta ”Olen kristitty” jatkaaksesi, tai Poistu / Takaisin, jos tämä ei ole kotisi."
  },
  "rules": {
    "eyebrow": "Yhteisön liitto",
    "title": "Miten kohtelemme toisiamme",
    "text": "Vahvista jokainen sääntö. Kaikki kolme vaaditaan. Rikkomukset johtavat pysyvään poistoon. Väärät profiilit bannataan ikuisesti.",
    "agreeContinue": "Hyväksyn — jatka",
    "respectful": {
      "title": "Ole kunnioittava",
      "description": "Puhu ja toimi arvokkaasti. Jokainen täällä on luotu Jumalan kuvaksi."
    },
    "noSexualContent": {
      "title": "Ei seksuaalista sisältöä",
      "description": "Ei eksplisiittisiä kuvia, viestejä tai pyyntöjä. Puhtaus ei ole täällä valinnaista."
    },
    "noDominance": {
      "title": "Älä dominoi tai hallitse",
      "description": "Ei pakottamista, manipulointia tai painostusta. Rakkaus ei hallitse."
    },
    "hint": "Merkitse kaikki kolme lupausta ennen kuin jatkat."
  },
  "intent": {
    "eyebrow": "",
    "title": "Mitä etsit?",
    "text": "",
    "marriage": {
      "label": "Elämänkumppania",
      "description": ""
    },
    "discernment": {
      "label": "Vakavaa harkintaa",
      "description": ""
    },
    "notCasual": {
      "label": "Ei mitään kevyttä",
      "description": ""
    },
    "hint": "Valitse yksi."
  },
  "account": {
    "eyebrow": "Tili",
    "title": "Luo pääsysi",
    "text": "Handlesi luo vakaan käyttäjätunnuksen. Hakemus, vahvistus, tykkäykset ja matchit sidotaan siihen. Sähköpostia ei lähetetä.",
    "recoveryTitle": "Tallenna palautuskoodisi",
    "recoveryText": "Näytetään kerran. Ilman sitä kadonnutta salasanaa ei voi nollata tässä suljetussa testissä.",
    "savedContinue": "Olen tallentanut sen — jatka",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com tai lyhyt handle",
    "passphrase": "Salasana",
    "passphrasePlaceholder": "Vähintään 8 merkkiä",
    "signedInTitle": "Kirjautunut sisään",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Luottamusstandardi",
    "trustBody": "Mikään profiili ei näy ennen kuin henkilöllisyys on vahvistettu ja moderointi on hyväksynyt sinut.",
    "continueToVerification": "Jatka vahvistukseen",
    "hintEmail": "Kirjoita sähköpostiosoite, jossa on @.",
    "hintPassword": "Valitse salasana, jossa on vähintään 8 merkkiä."
  },
  "verify": {
    "intro": {
      "eyebrow": "Vahvistus",
      "title": "Luottamus on portti",
      "text": "Lataa virallinen henkilöllisyystodistus, vahvistusvideo ja {min}–{max} aitoa kuvaa. Kaikki menee tarkistusjonoon ennen kuin profiilisi voi näkyä.",
      "whyTitle": "Miksi vahvistamme",
      "whyBody": "Catfishingille ja puolivalheille ei ole sijaa täällä. Väärät profiilit bannataan pysyvästi. Media tallennetaan tilalla pending_review kunnes se hyväksytään.",
      "start": "Aloita vahvistus"
    },
    "steps": {
      "id": {
        "title": "Virallinen henkilöllisyystodistus",
        "description": "Passi tai kansallinen henkilökortti — kamera tai tiedoston lataus."
      },
      "video": {
        "title": "Vahvistusvideo",
        "description": "Lyhyt tallenne, joka osoittaa että olet paikalla."
      },
      "photos": {
        "title": "Aitoja kuvia",
        "description": "Seitsemästä kymmeneen selkeää kuvaa itsestäsi."
      },
      "review": {
        "title": "Eheystarkistus",
        "description": "Lataukset pysyvät pending_review-tilassa kunnes henkilökunta vahvistaa."
      }
    },
    "id": {
      "eyebrow": "Vaihe 1 / 4",
      "title": "Virallinen henkilöllisyystodistus",
      "text": "Ota tai lataa passisi tai kansallinen henkilökorttisi. Mitään ei julkaista julkisesti — tila pysyy pending_review kunnes henkilökunta vahvistaa.",
      "savedTitle": "Henkilöllisyystodistus tallennettu",
      "savedBody": "Seuraavaksi lyhyt vahvistusvideo kasvoistasi, sitten 7–10 aitoa kuvaa itsestäsi. Jatka avautuu, kun tämä henkilöllisyystodistus näyttää tallennetulta.",
      "hint": "Ota tai lataa kuva virallisesta henkilöllisyystodistuksestasi ja odota, kunnes siinä lukee tallennettu."
    },
    "video": {
      "eyebrow": "Vaihe 2 / 4",
      "title": "Vahvistusvideo",
      "text": "Nauhoita lyhyt klippi tai lataa yksi. Katso kameraan. Puhu selkeästi. Tämä osoittaa että olet paikalla — et kaavittu galleria.",
      "hint": "Nauhoita lyhyt vahvistusvideo ja odota, kunnes siinä lukee tallennettu."
    },
    "photos": {
      "eyebrow": "Vaihe 3 / 4",
      "title": "Aitoja kuvia",
      "text": "Lisää {min}–10 tuoretta kuvaa itsestäsi. Käytä kameraa tai kirjastoa. Napauta × poistaaksesi otoksen.",
      "continueToReview": "Jatka tarkistukseen",
      "hint": "Lisää {min}–10 selkeää kuvaa itsestäsi. Jatka avautuu, kun ne on tallennettu."
    },
    "review": {
      "eyebrow": "Vaihe 4 / 4",
      "title": "Eheystarkistus",
      "text": "Media jonossa tilassa pending_review{underUser}. Matchit ja tykkäykset käyttävät samaa id:tä.",
      "underUser": " käyttäjällä {userId}",
      "governmentId": "Virallinen henkilöllisyystodistus",
      "confirmationVideo": "Vahvistusvideo",
      "photos": "Kuvat",
      "missing": "Puuttuu",
      "filesReady": "{count} tiedostoa valmiina",
      "submittedTitle": "Lähetetty tarkistukseen",
      "submittedText": "Hakemus-id on sama kuin auth-käyttäjä-id, jotta hyväksyntä → pool ja molemminpuoliset tykkäykset pysyvät linjassa.",
      "submitContinue": "Lähetä ja jatka"
    }
  },
  "setup": {
    "eyebrow": "Tilin asetukset",
    "title": "Kerro totuus itsestäsi",
    "text": "Nämä vastaukset muovaavat matchausta ja näkyvät tarkistuksessa. Pehmeät valheet tuhlaavat kaikkien aikaa — myös sinun.",
    "beginSetup": "Aloita asetukset",
    "pillars": {
      "faith": {
        "name": "Usko",
        "text": "Miksi seuraat Kristusta."
      },
      "character": {
        "name": "Luonne",
        "text": "Uskollisuus, rehellisyys, intohimo, sitoutuminen — asteikolla 1–10."
      },
      "story": {
        "name": "Tarina",
        "text": "Kuka olet ja mitä etsit."
      },
      "life": {
        "name": "Elämä",
        "text": "Harrastukset, lukeminen ja ammatti."
      }
    },
    "whyChristian": {
      "eyebrow": "Usko",
      "title": "Miksi olet kristitty?",
      "text": "Lyhyt, rehellinen vastaus. Ei saarna — syy, joka on sinun.",
      "label": "Vastauksesi",
      "placeholder": "esim. Tapasin Kristuksen menetyksen kaudella ja olen seurannut Häntä siitä lähtien…",
      "hint": "Kirjoita vähintään {min} merkkiä siitä, miksi seuraat Jeesusta."
    }
  },
  "scales": {
    "eyebrow": "Luonneasteikot",
    "title": "Arvioi itsesi rehellisesti",
    "text": "Uskollisuus, rehellisyys, intohimo, sitoutuminen — kukin 1–10. Numeroiden paisuttaminen johtaa vain väärään matchiin myöhemmin. Sinun on asetettava jokainen asteikko jatkaaksesi.",
    "loyalty": {
      "label": "Uskollisuuden taso",
      "hint": "Ole rehellinen — kuinka uskollisesti seisot rakastamiesi rinnalla?"
    },
    "honesty": {
      "label": "Rehellisyyden taso",
      "hint": "Kuinka johdonmukaisesti kerrot koko totuuden?"
    },
    "passion": {
      "label": "Kuinka intohimoinen olet?",
      "hint": "Vakaumus ja syvyys — ei esitystä."
    },
    "commitment": {
      "label": "Sitoutumisen taso",
      "hint": "Kuinka valmis olet rakentamaan jotain kestävää?"
    },
    "hint": "Siirrä jokaista liukusäädintä niin että numero näkyy — mikään ei saa jäädä viivaksi."
  },
  "about": {
    "eyebrow": "Sinusta",
    "title": "Kuvaile itseäsi muutamalla lauseella",
    "text": "Kuka olet, kun kukaan ei esitä. Temperamentti, rytmi, mikä merkitsee arjessa.",
    "label": "Sinusta",
    "placeholder": "Hiljaiset aamut, vakava perheestä, nauran helposti, mieluummin syvyyttä kuin melua…",
    "hint": "Kirjoita vähintään {min} merkkiä itsestäsi."
  },
  "looking": {
    "eyebrow": "Kumppani",
    "title": "Mitä etsit?",
    "text": "Tärkeimmät luonteenpiirteet, joita toivot mahdolliselta kumppanilta — ei ulkonäön ostoslista.",
    "label": "Toivotut luonteenpiirteet",
    "placeholder": "esim. Vankka usko, emotionaalinen kypsyys, ystävällisyys paineessa…",
    "hint": "Kirjoita vähintään {min} merkkiä kumppanista, jota toivot."
  },
  "loveReady": {
    "eyebrow": "Kynnys",
    "title": "Oletko valmis tapaamaan elämäsi rakkauden?",
    "text": "UN8 on olemassa, jotta vakavat sinkut löytävät kumppanin — ja poistavat sovelluksen. Vain ”Kyllä” avaa jatkamisen.",
    "yesTitle": "Kyllä — olen valmis",
    "yesBody": "Olen täällä tapaamaan ihmiseni selkeydellä ja rohkeudella.",
    "noTitle": "Ei vielä",
    "noBody": "Jos vain selailet, tämä yhteisö ei ole oikea sinulle.",
    "comeBackTitle": "Palaa kun olet valmis",
    "comeBackBody": "UN8 on ihmisille, jotka ovat valmiita tapaamaan — ei keräämään vaihtoehtoja. Käytä alla Poistu, jos haluat lopettaa toistaiseksi. Vastauksesi on tallennettu tälle puhelimelle.",
    "hintNo": "Vain ”Kyllä” jatkaa. Jos et ole valmis, napauta Poistu toistaiseksi — vastauksesi pysyvät tällä puhelimella.",
    "hintUnset": "Napauta Kyllä, jos olet valmis tapaamaan jonkun avioliittoa varten."
  },
  "lifestyle": {
    "eyebrow": "Elämäntapa",
    "title": "Miten elät arjessa",
    "text": "Urheilu, harrastukset, lukeminen ja ammatti — käytännön signaaleja todellisesta yhteensopivuudesta.",
    "hobbies": "Nykyiset urheilulajit tai harrastukset",
    "hobbiesPlaceholder": "Mitä teet aktiivisesti — et mitä teit kerran.",
    "reading": "Luetko?",
    "readingHint": "1 = melkein ei koskaan · 10 = päivittäin, syvää lukemista",
    "profession": "Ammatti / ala",
    "professionPlaceholder": "esim. Hoitotyö · Ohjelmisto · Opetus · Käsiammatti",
    "hintHobbies": "Nimeä ainakin yksi urheilulaji tai harrastus, jota oikeasti teet.",
    "hintReading": "Siirrä ”Luetko?” niin että numero 1–10 näkyy.",
    "hintProfession": "Kirjoita työsi, vaikka lyhyt sana."
  },
  "faithDepth": {
    "eyebrow": "Matchaus · Usko",
    "title": "Kuinka keskeinen uskosi on?",
    "text": "Jumalan palveleminen — kuinka tärkeää elämässäsi? Vastaa rehellisesti. Matchaus käyttää tätä syvyyteen, ei esitykseen.",
    "serving": "Jumalan palveleminen — tärkeys",
    "servingHint": "10 % … 100 %. Siirrä 10:n askelin.",
    "keepsCommandments": "Pidätkö käskyt?",
    "grewUpInChurch": "Kasvoitko seurakunnassa?",
    "churchAttendance": "Seurakuntakäynti",
    "frequent": {
      "label": "Usein",
      "hint": "Säännöllinen kokoontuminen Kristuksen ruumiin kanssa."
    },
    "seldom": {
      "label": "Harvoin",
      "hint": "Satunnaisesti, ei viikoittainen rytmi."
    },
    "never": {
      "label": "Ei koskaan",
      "hint": "Ei tällä hetkellä käy."
    },
    "spreadsGospel": "Levitätkö evankeliumia?",
    "hasIdols": "Onko sinulla epäjumalia?",
    "hintServing": "Siirrä, kuinka tärkeää Jumalan palveleminen on elämässäsi.",
    "hintCommandments": "Vastaa pidätkö käskyt — Kyllä tai Ei.",
    "hintGrewUp": "Vastaa kasvoitko seurakunnassa — Kyllä tai Ei.",
    "hintAttendance": "Valitse kuinka usein käyt seurakunnassa.",
    "hintGospel": "Vastaa jaatko evankeliumia — Kyllä tai Ei.",
    "hintIdols": "Vastaa onko sinulla epäjumalia — Kyllä tai Ei."
  },
  "character": {
    "eyebrow": "Matchaus · Luonne",
    "title": "Kuka olet kotona",
    "text": "Luonne kosintaa varten — rauhantekijä, tavat, rehellisyys. Vastausten paisuttaminen johtaa vain väärään matchiin myöhemmin.",
    "peacemaker": "Oletko rauhantekijä?",
    "homebuilder": "Oletko kodin rakentaja?",
    "humorous": "Oletko humoristinen?",
    "caring": "Huolehtiva ja hellä?",
    "peacefulHome": "Haluatko rauhallisen kodin — ilman riitaa?",
    "manners": "Hyvät tavat?",
    "honestyRating": "Rehellisyysarvosana tässä kyselyssä",
    "honestyHint": "1–10 — kuinka rehellisesti vastaat?",
    "hintPeacemaker": "Vastaa jokaiseen Kyllä tai Ei, aloittaen rauhantekijästä.",
    "hintHomebuilder": "Vastaa oletko kodin rakentaja.",
    "hintHumorous": "Vastaa oletko humoristinen.",
    "hintCaring": "Vastaa oletko huolehtiva ja hellä.",
    "hintPeaceful": "Vastaa haluatko rauhallisen kodin.",
    "hintManners": "Vastaa onko sinulla hyvät tavat.",
    "hintHonesty": "Siirrä rehellisyysarvosanaasi 1–10."
  },
  "history": {
    "eyebrow": "Matchaus · Historia",
    "title": "Menneisyys ja valmius",
    "text": "Päihteet, lapsuus, arvet ja oletko valmis kestävään suhteeseen. Totuus täällä suojaa teitä molempia.",
    "marijuana": "Oletko käyttänyt marihuanaa?",
    "lsd": "Oletko käyttänyt LSD:tä?",
    "otherDrugs": "Oletko käyttänyt muita huumeita?",
    "addicted": "Oletko ollut riippuvainen?",
    "childhood": "Vakaa, rakastava lapsuus?",
    "scars": "Arpia / vahingoittunut?",
    "lasting": "Valmis kestävään suhteeseen?",
    "hintStart": "Vastaa jokaiseen Kyllä tai Ei tällä sivulla, aloittaen ylhäältä.",
    "hintLsd": "Vastaa LSD-kysymykseen — Kyllä tai Ei.",
    "hintOtherDrugs": "Vastaa oletko käyttänyt muita huumeita.",
    "hintAddicted": "Vastaa oletko ollut riippuvainen.",
    "hintChildhood": "Vastaa oliko lapsuutesi vakaa ja rakastava.",
    "hintScars": "Vastaa kannatko arpia.",
    "hintLasting": "Vastaa oletko valmis kestävään suhteeseen."
  },
  "appearance": {
    "eyebrow": "Matchaus · Ulkonäkö",
    "title": "Tatuoinnit",
    "text": "Omat tatuointisi ja hyväksytkö tatuoinnit kumppanilla.",
    "hasTattoos": "Onko sinulla tatuointeja?",
    "acceptsPartner": "Hyväksytkö tatuoinnit kumppanilla?",
    "hintHas": "Sano onko sinulla tatuointeja — Kyllä tai Ei.",
    "hintAccepts": "Sano hyväksytkö tatuoinnit kumppanilla."
  },
  "home": {
    "eyebrow": "Matchaus · Koti ja maa",
    "title": "Maa, taidot, omavaraisuus",
    "text": "Yrtit, ruoan kasvatus, hedelmämetsä, valmistautuminen, yhteisöviljely, säilöntä, selviytyminen — ja erityistaidot.",
    "herbKnowledge": "Yrttitietämys?",
    "plantOwn": "Kasvatatko omia hedelmiä ja vihanneksia?",
    "fruitForest": "Kiinnostaako hedelmämetsä?",
    "prepping": "Valmistautuminen katastrofeihin?",
    "communityFarming": "Yhteisöviljely / itsenäinen asuminen?",
    "canning": "Säilöntä ja säilykkeet?",
    "survival": "Selviytymistaidot?",
    "specialSkills": "Erityistaidot (valinnainen)",
    "specialPlaceholder": "Mitä muuta tuot kotitalouteen tai maalle…",
    "hintStart": "Vastaa jokaiseen Kyllä tai Ei maasta ja taidoista, aloittaen ylhäältä.",
    "hintPlant": "Vastaa kasvatatko omia hedelmiä ja vihanneksia.",
    "hintFruitForest": "Vastaa kiinnostaako hedelmämetsä.",
    "hintPrepping": "Vastaa valmistaututko katastrofeihin.",
    "hintCommunity": "Vastaa kiinnostaako yhteisöviljely.",
    "hintCanning": "Vastaa säilötkö ruokaa.",
    "hintSurvival": "Vastaa onko sinulla selviytymistaitoja."
  },
  "family": {
    "eyebrow": "Matchaus · Perhe",
    "title": "Lapset, uskon syvyys, päihteet",
    "text": "Mitä tarvitset kumppanilta uskon intensiteetin, lasten ja entisen päihteiden käytön suhteen.",
    "children": "Lapset",
    "wants": {
      "label": "Haluaa lapsia",
      "hint": "Perheen rakentaminen on osa visiota."
    },
    "doesNotWant": {
      "label": "Ei halua lapsia",
      "hint": "Selvä ei lapsille."
    },
    "open": {
      "label": "Avoin",
      "hint": "Harkitsee — ei lukittu kumpaankaan."
    },
    "hasLivingWith": {
      "label": "On lapsia — asuu heidän kanssaan",
      "hint": "Lapset ovat jo osa arkea."
    },
    "requiredFaith": "Vähimmäususkon taso, jonka tarvitset kumppanilta",
    "requiredFaithHint": "10 % … 100 %. Kova portti kun molemmat ovat vastanneet.",
    "acceptsSubstances": "Hyväksytkö entisen päihteiden käytön kumppanilla?",
    "hintChildren": "Valitse yksi kortti lapsista.",
    "hintFaith": "Siirrä vähimmäususkon taso, jota toivot kumppanilta.",
    "hintSubstances": "Sano hyväksytkö entisen päihteiden käytön kumppanilla."
  },
  "ancestry": {
    "eyebrow": "Matchaus · Tausta",
    "title": "Taustamieltymykset",
    "text": "Jaa taustasi ja mihin olet avoin kumppanissa. Tämä muovaa vain sijoitusta — se ei koskaan piilota ketään pakasta.",
    "yourBackground": "Taustasi (valitse kaikki sopivat)",
    "openToPartner": "Avoin kumppanissa",
    "codeDesc": "Koodi: {code}",
    "anyDesc": "Vahvin mieltymys laajuuteen — suositellaan kun epävarma.",
    "preferenceOnly": "Vain mieltymys — ei portti.",
    "hintOwn": "Merkitse ainakin yksi tausta, joka kuvaa sinua. Tämä auttaa vain sijoitusta — se ei koskaan piilota ketään.",
    "hintAccepted": "Merkitse mihin olet avoin kumppanissa, tai ”Avoin — ei mieltymystä”."
  },
  "interests": {
    "eyebrow": "Matchaus · Kiinnostukset",
    "title": "Mistä nautit",
    "text": "Valitse ainakin yksi. Päällekkäisyys auttaa sijoitusta; hiljaisuutta ei koskaan rangaista.",
    "hint": "Merkitse ainakin yksi kiinnostus."
  },
  "reflection": {
    "eyebrow": "Matchaus · Pohdinta",
    "title": "Omilla sanoillasi",
    "text": "Nämä neljä vastausta näytetään kokonaan eikä niitä koskaan pisteytetä. Kirjoita mikä on totta.",
    "describeYourself": "Kuvaile itseäsi",
    "lifePurpose": "Elämän tarkoitus",
    "fifteenYear": "Sinä ja elämäsi rakkaus 15 vuoden päästä",
    "weaknesses": "Heikkoudet",
    "hintDescribe": "Kuvaile itseäsi vähintään {min} merkillä.",
    "hintPurpose": "Kirjoita elämäntarkoituksesi vähintään {min} merkillä.",
    "hintVision": "Kirjoita 15 vuoden visio vähintään {min} merkillä.",
    "hintWeaknesses": "Nimeä heikkous vähintään {min} merkillä."
  },
  "profile": {
    "eyebrow": "Profiili",
    "title": "Muutama olennainen",
    "text": "Pidä se yksinkertaisena. Sukupuoli on täällä binäärinen — mies tai nainen — selkeää matchausta varten.",
    "firstName": "Etunimi",
    "firstNamePlaceholder": "Kuten haluat tulla tunnetuksi",
    "age": "Ikä",
    "agePlaceholder": "18+",
    "city": "Kaupunki",
    "cityPlaceholder": "Missä asut",
    "sex": "Sukupuoli",
    "maleBody": "Olen mies.",
    "femaleBody": "Olen nainen.",
    "hintName": "Kirjoita etunimesi (vähintään kaksi kirjainta).",
    "hintAge": "Iän on oltava 18 tai enemmän.",
    "hintCity": "Kirjoita kaupunki jossa asut.",
    "hintGender": "Valitse Mies tai Nainen jotta matchaus toimii."
  },
  "ready": {
    "title": "Saat tulla sisään.",
    "textNamed": "{name}, vahvistuksesi ja asetuksesi on tallennettu. Media on pending_review. Tervetuloa UN8en — löydä ihmisesi, sitten poista sovellus.",
    "text": "Vahvistuksesi ja asetuksesi on tallennettu. Media on pending_review. Tervetuloa UN8en — löydä ihmisesi, sitten poista sovellus.",
    "summaryAria": "Asetusten yhteenveto",
    "christianRules": "Kristitty · säännöt vahvistettu",
    "mediaLine": "Henkilöllisyys · video · {photoCount} kuvaa · jono {pending}",
    "scalesLine": "Asteikot L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sukupuoli —",
    "professionFallback": "ammatti",
    "userLine": "Käyttäjä {userId}",
    "enterMatching": "Siirry matchaukseen",
    "needGender": "Palaa profiilivaiheeseen ja valitse Mies tai Nainen, sitten yritä uudelleen."
  },
  "match": {
    "brandTag": "Matchaus",
    "navOnboarding": "Käyttöönotto",
    "navReview": "Tarkistus",
    "navMatching": "Matchaus",
    "logOut": "Kirjaudu ulos",
    "enterTitle": "Siirry matchaukseen",
    "enterText": "Kirjaudu sisään samalla sähköpostilla kuin käyttöönotossa. Hakemus, pool, tykkäykset ja matchit käyttävät kaikki vakaata käyttäjä-id:täsi.",
    "email": "Sähköposti",
    "emailPlaceholder": "you@example.com",
    "password": "Salasana",
    "passwordPlaceholder": "Salasanasi",
    "logIn": "Kirjaudu sisään",
    "guestOr": "Tai kokeile vierassessiota (vakaa id per selain · vain demo)",
    "guestMan": "Vieras miehenä",
    "guestWoman": "Vieras naisena",
    "goOnboarding": "Siirry käyttöönottoon →",
    "guestSession": "Vierassessio · demo-pool",
    "packTitle": "Sinun neljäsi",
    "packSkip": "Napauta jatkaaksesi",
    "newSelection": "Uusi valinta",
    "backToFour": "← Takaisin neljääsi",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "mies",
    "woman": "nainen",
    "navSelection": "Valinta",
    "navMessages": "Viestit",
    "navProfile": "Profiili",
    "tabToday": "Valinta",
    "tabMatches": "Matchit ({count})",
    "yourMatches": "Matchisi",
    "matchesSub": "Pysyvä molemminpuolinen kiinnostus · {count} lähtevää {likesWord}",
    "like": "tykkäys",
    "likes": "tykkäystä",
    "emptyMatches": "Ei vielä vastavuoroista kiinnostusta. Jatka tämän viikon valinnan erottelua.",
    "valuesScore": "Arvot {score}",
    "chatOpen": " · Chat auki",
    "tapToChat": " · Napauta chattaaksesi",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Arvot {score}",
    "noProfileYet": "Ei vielä profiilia",
    "noProfileText": "Viimeistele käyttöönotto tai napauta Käyttöönotto ylhäällä, sitten Aloita. Vierasmatchaus on sisäänkirjautumisnäytöllä, jos haluat vain katsoa.",
    "matchingPaused": "Matchaus tauolla",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Ei vielä ketään näytettäväksi",
    "todaysSetDone": "Tämä on tämän viikon valinta",
    "weeklyTitle": "Tämän viikon 4",
    "weeklyTitleCount": "Tämän viikon {count}",
    "weeklyCountdown": "Seuraava valinta {days} päivän kuluttua",
    "weeklyCountdownOne": "Seuraava valinta 1 päivän kuluttua",
    "weeklyCountdownSoon": "Seuraava valinta pian",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Tämä on tämän viikon valinta",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Tämän viikon listalla ei ole vielä ketään. Allas täyttyy — avaa Valinta hetken päästä tai palaa, kun lisää jäseniä on hyväksytty.",
    "emptyDone": "Olet käynyt tämän viikon valinnan läpi. Palaa seuraavaan avaukseen tai nollaa pakka.",
    "likesMayNotStick": " Tykkäykset eivät ehkä jää.",
    "poolMeta": "Pool: {pool} · Matchit: {matches} · Tykkäsi: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Nollaa pakka",
    "backOnboarding": "Takaisin käyttöönottoon",
    "feedEyebrowDemo": "Viikon valinta · Demo",
    "feedEyebrowLive": "Viikon valinta · Allas ({source}, {count})",
    "feedTitle": "Harkitse huolella",
    "left": "{count} jäljellä",
    "pass": "Ohita",
    "interested": "Kiinnostunut",
    "swipeHint": "Swippaa tai käytä painikkeita. Match aukeaa vain kun kiinnostus on molemminpuolista ja tallennettua.",
    "celebrationEyebrow": "Molemminpuolinen kiinnostus",
    "celebrationTitle": "Matchasit",
    "celebrationText": "{self} ja {other} molemmat osoittivat kiinnostusta. Arvojen linjaus: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat on avattu tälle matchille. Pidä se kunnioittavana — liitto yli mukavuuden.",
    "openChat": "Avaa chat",
    "keepDiscerning": "Jatka harkintaa",
    "cardSeeking": "Etsii",
    "cardHobbies": "Harrastukset",
    "affinity": "Yhteensopivuus",
    "valuesScoreLabel": "Arvopisteet",
    "scoreStrong": "Vahva linjaus",
    "scoreSolid": "Vankka linjaus",
    "scoreModerate": "Kohtalainen linjaus",
    "scoreDifferent": "Erilaiset rytmit",
    "characterAxisFoot": "Luonneakseli sisältää neljä pilaria",
    "youThem": "Sinä {self} · He {other}",
    "stampInterest": "Kiinnostus",
    "stampPass": "Ohita",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Arvopisteenne ovat lähellä toisiaan ({score} / 100).",
    "explainLegacyFuller": "Täydempi ”miksi” näkyy kun molemmat olette vastanneet matchauskysymyksiin.",
    "explainFaith": "Uskonne intensiteetti on lähellä — otatte Jeesuksen seuraamisen yhtä vakavasti.",
    "explainCharacter": "Tapanne kohdella ihmisiä kotona linjautuu — rauha, tavat ja huolenpito.",
    "explainPurpose": "Arvioitte oman rehellisyytenne samalla tavalla, mikä on merkki yhteisestä vakavuudesta.",
    "explainHome": "Jaatte kiinnostuksen maahan, ruoan kasvatukseen tai omavaraiseen kotiin.",
    "explainAncestry": "Molemmat suositte samanlaisia perhetaustoja. Se on mieltymys, ei suodatin — ketään ei piiloteta sen takia.",
    "explainTemperament": "Kiinnostuksenne ja temperamenttinne menevät päällekkäin.",
    "explainFallback": "Mahdollinen match vastauksissa, jotka molemmat täytitte.",
    "explainOverall": "Kokonaisyhteensopivuus {score} / 100.",
    "affinityAxes": {
      "faith": "Uskon intensiteetti",
      "character": "Luonne ja käytös",
      "purpose": "Elämäntarkoituksen linjaus",
      "home": "Koti ja omavaraisuus",
      "ancestry": "Kulttuuri- ja taustayhteensopivuus",
      "temperament": "Temperamentin sopivuus"
    },
    "scaleAxes": {
      "loyalty": "Uskollisuus",
      "honesty": "Rehellisyys",
      "passion": "Intohimo",
      "commitment": "Sitoutuminen"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat ei saatavilla",
    "unavailableText": "Tämä match puuttuu tai ei kuulu sessioosi.",
    "backToMatches": "Takaisin matcheihin",
    "backMatches": "← Matchit",
    "valuesSubscriber": "Arvot {score} · Tilaaja",
    "valuesTrial": "Arvot {score} · Kokeilu",
    "valuesKept": "Arvot {score} · Match säilytetty",
    "empty": "Sano hei huolella. Jaetulla backendillä viestit synkronoituvat molempiin puhelimiin molemminpuolisen matchin jälkeen.",
    "placeholder": "Viesti {name}…",
    "ariaMessage": "Viesti",
    "send": "Lähetä"
  },
  "billing": {
    "paywallCopy": "Ilmaisen kokeilun jälkeen pidät kaikki, joiden kanssa olet jo matchannut, ja jatkat chattailua. Nähdäksesi uusia ihmisiä, tilaa.",
    "signInToMatch": "Kirjaudu sisään käyttääksesi matchausta.",
    "signInFirst": "Kirjaudu ensin sisään.",
    "subscriberUntil": "Tilaaja · {date} asti",
    "renewal": "uusinta",
    "freeTrial": "Ilmainen kokeilu · {days} päivää (päättyy {date})",
    "soon": "pian",
    "trialEnded": "Kokeilu päättynyt · matchit ja chat pysyvät auki",
    "subscribe": "Tilaa · ${price}/kk",
    "subscribeEarly": "Tilaa ajoissa · ${price}/kk",
    "activeNote": "Tilaus aktiivinen — näet taas uusia ihmisiä.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Tallenna palautuskoodisi",
    "recoveryText": "Kirjoita tämä ylös nyt. Se näytetään kerran. Jos menetät salasanasi, tämä koodi on ainoa tapa nollata se suljetussa testissä.",
    "savedContinue": "Olen tallentanut sen — jatka",
    "welcomeBack": "Tervetuloa takaisin",
    "createAccount": "Luo tilisi",
    "intro": "Handle ja salasana. Sähköpostia tai SMS:ää ei lähetetä. Id:si pysyy vakaana käyttöönotossa, tarkistuksessa ja matchauksessa.",
    "tabLogin": "Kirjaudu sisään",
    "tabRegister": "Rekisteröidy",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com tai lyhyt handle",
    "passphrase": "Salasana",
    "passphrasePlaceholder": "Vähintään 8 merkkiä",
    "submitLogin": "Kirjaudu sisään",
    "submitRegister": "Luo tili",
    "backWelcome": "Takaisin tervetuloon"
  },
  "options": {
    "origin": {
      "african": "Afrikkalainen",
      "european": "Eurooppalainen",
      "asian": "Aasialainen",
      "latino": "Latino / Hispanic",
      "middleEastern": "Lähi-itä",
      "indigenous": "Alkuperäiskansa",
      "mixed": "Sekalainen",
      "other": "Muu",
      "dutch": "Hollantilainen",
      "german": "Saksalainen",
      "any": "Avoin — ei mieltymystä"
    },
    "interest": {
      "prayer": "Rukous",
      "worship": "Palvonta",
      "reading": "Lukeminen",
      "hiking": "Vaellus",
      "music": "Musiikki",
      "cooking": "Ruoanlaitto",
      "farming": "Viljely / puutarha",
      "sports": "Urheilu",
      "missions": "Lähetystyö",
      "family": "Perhe-elämä",
      "crafts": "Käsityöt",
      "outdoors": "Ulkoilu"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Kyllä",
      "no": "Ei"
    },
    "id": {
      "titleEmpty": "Virallinen henkilöllisyystodistus",
      "titleReady": "Henkilöllisyystodistus valmis",
      "hintEmpty": "Passi tai kansallinen henkilökortti. Ota live-kuva tai valitse kuva/PDF. Kaikki neljä kulmaa näkyvissä.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · tallennettu",
      "previewAlt": "Henkilöllisyystodistuksen esikatselu",
      "pdfAria": "PDF-asiakirja valittu",
      "takePhoto": "Ota kuva",
      "retake": "Ota uudelleen",
      "chooseFile": "Valitse tiedosto",
      "replaceFile": "Vaihda tiedosto",
      "remove": "Poista",
      "uploading": "Ladataan…",
      "cameraTitle": "Kuvaa henkilöllisyystodistuksesi",
      "signIn": "Kirjaudu sisään ennen henkilöllisyystodistuksen lataamista.",
      "uploadFailed": "Lataus epäonnistui. Yritä uudelleen.",
      "badFile": "Tiedostoa ei voitu käyttää."
    },
    "video": {
      "titleEmpty": "Vahvistusvideo",
      "titleLive": "Kamera päällä",
      "titleReady": "Video valmis",
      "hintEmpty": "Sano etunimesi ja että liityt UN8en rehellisesti. 5–15 sekuntia.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Nauhoita",
      "cameraUpload": "Kamera-upload",
      "chooseFile": "Valitse tiedosto",
      "startRecording": "Aloita nauhoitus",
      "cancel": "Peruuta",
      "stopSave": "Pysäytä ja tallenna",
      "recordAgain": "Nauhoita uudelleen",
      "replaceFile": "Vaihda tiedosto",
      "remove": "Poista",
      "unsupported": "Live-nauhoitus ei ole saatavilla täällä. Käytä kamera-uploadia tai valitse tiedosto.",
      "permissionDenied": "Kameran lupa evätty. Voit silti ladata lyhyen videotiedoston.",
      "signIn": "Kirjaudu sisään ennen videon lataamista.",
      "uploadFailed": "Lataus epäonnistui. Yritä uudelleen.",
      "saveFailed": "Nauhoitusta ei voitu tallentaa.",
      "badVideo": "Videota ei voitu käyttää."
    },
    "photos": {
      "count": "{count} / {max} kuvaa",
      "minimumMet": "Minimi täytetty",
      "moreRequired": "{n} lisää vaaditaan",
      "listAria": "Vahvistuskuvat",
      "photoAlt": "Kuva {n}",
      "removeAria": "Poista kuva {n}",
      "camera": "Kamera",
      "takePhoto": "Ota kuva",
      "chooseFiles": "Valitse tiedostoja",
      "uploading": "Ladataan…",
      "hint": "Ota kuva avaa live-kameran. Valitse tiedostoja on vain galleriavalinnoille. Selkeät kasvokuvat — ei suodattimia jotka peittävät henkilöllisyyden. Max {max}.",
      "cameraTitle": "Ota kuva itsestäsi",
      "signIn": "Kirjaudu sisään ennen kuvien lataamista.",
      "someFailed": "Joidenkin kuvien lataus epäonnistui. Yritä epäonnistuneet uudelleen.",
      "addFailed": "Kuvia ei voitu lisätä."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Sulje",
      "capture": "Ota",
      "cancel": "Peruuta",
      "hint": "Pidä vakaa. Live-kamera pysyy auki kunnes otat kuvan.",
      "unavailable": "Kamera ei ole saatavilla tässä selaimessa. Käytä sen sijaan Valitse tiedosto.",
      "permissionDenied": "Kameran lupa evätty tai ei saatavilla. Käytä sen sijaan Valitse tiedosto.",
      "frameFailed": "Tätä ruutua ei voitu kaapata.",
      "saveFailed": "Kuvaa ei voitu tallentaa."
    },
    "uploadStatus": {
      "uploading": "ladataan…",
      "failed": "lataus epäonnistui",
      "savedLocally": "tallennettu paikallisesti",
      "uploaded": "ladattu",
      "stored": "tallennettu",
      "awaitingUpload": "Odottaa latausta",
      "localFallbackNote": "{error} Tiedosto on tallennettu tälle laitteelle; yritä uudelleen kun sign-endpoint on ylhäällä."
    }
  },
  "language": {
    "label": "Kieli",
    "choose": "Valitse kieli"
  },
  "shell": {
    "back": "Takaisin",
    "goBackAria": "Takaisin"
  }
} as Messages;
